import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Collapse, ListGroup, Row } from 'react-bootstrap-5';
import PrimaryToggle from './primary_toggle';
import ContactMethod from './contact_method';
import ActionsDropdown from './actions_dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import ContactSection from './contact_section';
import { CONTACT_MODEL } from '../../../constants';
import ConnectTagManager from '../../tags/connect_tag_manager';

export default function Ownership({ index, notCollapsible, owner }) {
  const { contact } = owner;
  const [open, setOpen] = useState(notCollapsible || index === 0);

  return (
    <ListGroup.Item className="pb-4">
      <Row className="align-items-center">
        <Col className="text-muted fw-bold">Contact</Col>
        <Col className="d-flex align-items-center" xs="auto">
          <PrimaryToggle owner={owner} />
          <ActionsDropdown owner={owner} />
          {!notCollapsible && (
            <Button className="btn-icon" variant="secondary-text" onClick={() => setOpen(!open)}>
              <FontAwesomeIcon icon={faAngleRight} rotation={open ? 90 : undefined} />
            </Button>
          )}
        </Col>
      </Row>
      <div className="fs-large fw-bold mb-4">{contact.name}</div>
      <Collapse in={open}>
        <div>
          <ConnectTagManager
            initialTags={owner.contact.tags}
            recordId={owner.contact.id}
            recordType={CONTACT_MODEL}
          />
          <div className="d-flex flex-column gap-3 mt-4">
            {contact.phoneNumbers.length > 0 && (
              <ContactSection defaultOpen={true} title="Phone Number">
                <ContactMethod
                  contactMethodKey="phoneNumbers"
                  owner={owner}
                  renderDisplayName={phoneNumber => (
                    <div className="d-flex align-items-center flex-wrap">
                      <a href={`tel:${phoneNumber.number}`} target="_top">{phoneNumber.formatted}</a>
                      <small className="ms-1 text-muted">{phoneNumber.label}</small>
                    </div>
                  )}
                />
              </ContactSection>
            )}
            {contact.emails.length > 0 && (
              <ContactSection defaultOpen={true} title="Email Address">
                <ContactMethod
                  contactMethodKey="emails"
                  owner={owner}
                  renderDisplayName={email => (
                    <a className="text-truncate" href={`mailto:${email.email}`} target="_top">{email.email}</a>
                  )}
                />
              </ContactSection>
            )}
            {contact.addresses.length > 0 && (
              <ContactSection title="Address">
                <ContactMethod
                  contactMethodKey="addresses"
                  owner={owner}
                  renderDisplayName={address => (
                    <div>
                      <div>{address.twoLine[0]}</div>
                      <div>{address.twoLine[1]}</div>
                    </div>
                  )}
                />
              </ContactSection>
            )}
          </div>
        </div>
      </Collapse>
    </ListGroup.Item>
  );
}

Ownership.propTypes = {
  index: PropTypes.number,
  notCollapsible: PropTypes.bool,
  owner: PropTypes.shape({
    id: PropTypes.number.isRequired,
    primary: PropTypes.bool.isRequired,
    contact: PropTypes.shape({
      addresses: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        twoLine: PropTypes.arrayOf(PropTypes.string).isRequired
      })).isRequired,
      emails: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        email: PropTypes.string.isRequired
      })).isRequired,
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      phoneNumbers: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired
      })).isRequired
    }).isRequired
  })
};
